import React from 'react';
import {Box, Container, Grid } from '@material-ui/core';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import {MetaTags} from 'react-meta-tags';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import '../styles/bizofficer-a.css';

const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

  export default function Execute() {
	const classes = useStyles();
	
		return (
			<div> 
				<MetaTags>
            		<title>Payment Transaction Failed</title>
          		</MetaTags>
				
				<Header />	
				<LeftDrawer />
				<main className={classes.content}>
				

				<Box mt={1}>
						<Grid container spacing={2}>
							<Grid item   md={12} xs={12} style={{textAlign:'center'}}>
								<div><ReportGmailerrorredIcon style={{fontSize:60,color:'#fe3000'}} /></div>
								<h3 className="heading" style={{color:'#fe3000'}} >Payment Transaction Failed</h3>
								<h3>Don't worry, You can try again.</h3>
								<br/>
								<p>
								<a href="selectcourse">Try again</a>
								</p>
								<br/> OR <br/><br/> 
								<p>
								<a href="dashboard">Go to your dashboard</a>
								</p>
							</Grid>
						</Grid>
				</Box>				

				

					

				</main>
				
				

			</div>
		);
 
}